import axiosClient from "./axios";

// 1. Anı Defteri Oluştur
export const postMemoryBookInitiate = async (data) => {
  try {
    const response = await axiosClient.post(`/module/memory-book/initiate`, data);
    return response.data;
  } catch (error) {
    console.error("Anı defteri oluşturulurken hata:", error);
    throw error;
  }
};

// 2. Anı Defterleri Listesi
export const getMemoryBookList = async () => {
  try {
    const response = await axiosClient.get(`/module/memory-book/list`);
    return response.data;
  } catch (error) {
    console.error("Anı defterleri listesi alınırken hata:", error);
    throw error;
  }
};

// 3. Anı Defteri Detayı
export const getMemoryBookSingle = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/memory-book/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Anı defteri detayı alınırken hata:", error);
    throw error;
  }
};

// 4. Anı Defteri Paylaş
export const postMemoryBookShare = async (memoryBookUuid, email, permission = "read") => {
  try {
    const response = await axiosClient.post(`/module/memory-book/share`, {
      memory_book_uuid: memoryBookUuid,
      email: email,
      permission: permission
    });
    return response.data;
  } catch (error) {
    console.error("Anı defteri paylaşılırken hata:", error);
    throw error;
  }
};

// 5. Paylaşım Durumunu Güncelle (Kabul Et / Sil)
export const updateMemoryBookShareStatus = async (shareId, action) => {
  try {
    const response = await axiosClient.post(`/module/memory-book/share/${shareId}/update`, {
      action: action // 1 = kabul et, 2 = sil
    });
    return response.data;
  } catch (error) {
    console.error("Paylaşım durumu güncellenirken hata:", error);
    throw error;
  }
};

// 6. Paylaşım Permission Güncelle
export const updateMemoryBookSharePermission = async (shareId, permission) => {
  try {
    const response = await axiosClient.put(`/module/memory-book/share/${shareId}/permission`, {
      permission: permission // "read" veya "write"
    });
    return response.data;
  } catch (error) {
    console.error("Paylaşım permission güncellenirken hata:", error);
    throw error;
  }
};

// 7. Anı Defteri Sil
export const deleteMemoryBook = async (uuid) => {
  try {
    const response = await axiosClient.delete(`/module/memory-book/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Anı defteri silinirken hata:", error);
    throw error;
  }
};

// 8. Anı Defteri Yazılarını Getir
export const getMemoryBookEntries = async (uuid) => {
  try {
    const response = await axiosClient.get(`/module/memory-book/${uuid}/entries`);
    return response.data;
  } catch (error) {
    console.error("Anı defteri yazıları alınırken hata:", error);
    throw error;
  }
};

// 9. Anı Defterine Yazı Ekle
export const postMemoryBookAddEntry = async (uuid, data) => {
  try {
    const response = await axiosClient.post(`/module/memory-book/${uuid}/add-entry`, data);
    return response.data;
  } catch (error) {
    console.error("Anı defterine yazı eklenirken hata:", error);
    throw error;
  }
};

